/**
 * Created by pandemio on 2/12/19.
 */
import React from 'react';
import { Table } from 'reactstrap';

/**
 * Datatable class. We had problem with the pagination of the other libraries as
 * reactbootstraptable, so we decided to create own own
 * Example of data to send
 *  let headerOptions = [{name:'Id'}, {name:'First Name'}, {name:'amount'}];
 let data = [
 {
     id: '2', name: 'My Plan', value: '2', amount: '599'
 },
 {
     id: '3', name: 'My Plan three', value: '3', amount: '599'
 }
 ];
 */
class DataTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            totalToShowPerPage: props.totalToShowPerPage ? props.totalToShowPerPage : 0,
            headerOptions: props.headerOptions ? props.headerOptions : [],
            data: props.data ? props.data : [],
        };
        this.onRowClick = this.onRowClick.bind(this);
    }

    componentWillReceiveProps(props){
        this.setState({
            totalToShowPerPage: props.totalToShowPerPage ? props.totalToShowPerPage : 0,
            headerOptions: props.headerOptions ? props.headerOptions : [],
            data: props.data ? props.data : [],
        });
    }

    onRowClick(e){

        for(let i=0; i < this.state.data.length; i++)
        {
            if(this.state.data[i].value === e.target.getAttribute('value'))
                return  this.props.updateParent(this.state.data[i]);
        }
    }

    /**
     * Renders the pagination, always refreshing according to results
     * @returns {XML}
     */
    render() {
        let uniqueKey = 0;
        // Create header
        let trs = [];
        this.state.data.forEach((items)=>{
            let valueItem = items.value !== null && typeof items.value !== 'undefined' ? items.value : null;
            let tds = [];

            for(let item in items)
            {
                uniqueKey++;
                let keyName = (parseInt(valueItem) + parseInt(uniqueKey));
                // Push it if it is not a value. We do not need a value here
                if(item !== 'value')
                    tds.push(<td key={keyName} value={valueItem}>{items[item]}</td>);
            }
            trs.push(<tr onClick={this.onRowClick}>{tds}</tr>);
        });

        let uniqueKeyTr = 0;
        return (
            <div>
                <Table striped responsive>
                    <thead>
                        <tr>
                            {this.state.headerOptions.map((d)=>{
                                return (<th key={d.key}>{d.name}</th>)
                            })}
                        </tr>
                    </thead>
                    <tbody>
                    {trs}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default DataTable;